var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEaSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 29,
    viewBox: "0 0 52 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2666 0L22.5254 15.2112H11.9587L14.3525 11.4492H20.9568L23.3506 7.68702H8.65656L6.26251 11.4492H9.81227L5.02417 18.9731H24.7542L32.2666 7.11473L34.9909 11.4492H32.5968L30.2028 15.2112H37.3849L39.779 18.9731H44.3189L32.2666 0Z",
    fill: "#CC2229"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0465 0.163574H13.4441L11.05 3.92552H26.6524L29.0465 0.163574Z",
    fill: "#CC2229"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23418 22.162V23.2254H10.307V22.7345C10.307 21.4261 9.81204 21.0994 8.49133 21.0994H6.3449C5.02394 21.0994 4.61133 21.508 4.61133 22.8987V23.5529C4.61133 24.943 5.02394 25.27 6.3449 25.27H9.23443V27.4782H5.76704V26.3331H4.61133V26.824C4.61133 28.1324 5.02394 28.5413 6.3449 28.5413H8.65633C9.97728 28.5413 10.3899 28.1322 10.3899 26.824V25.9242C10.3899 24.6163 9.97728 24.2071 8.65633 24.2071H5.76704V22.1623H9.23418V22.162ZM36.2285 22.162H38.7878V21.0994H32.514V22.162H34.9906V28.5413H36.2285V22.162ZM44.1535 22.162V23.2254H45.2271V22.7345C45.2271 21.4261 44.7316 21.0994 43.4932 21.0994H41.347C39.9435 21.0994 39.6132 21.508 39.6132 22.8987V23.5529C39.6132 24.943 39.9435 25.27 41.347 25.27H44.2361V27.4782H40.439V26.3331H39.2832V26.824C39.2832 28.1324 39.6961 28.5413 41.0171 28.5413H43.5759C44.9789 28.5413 45.3092 28.1322 45.3092 26.824V25.9242C45.3092 24.6163 44.9789 24.2071 43.5759 24.2071H40.6863V22.1623H44.1535V22.162Z",
    fill: "#295BA7",
    stroke: "#295BA7",
    strokeWidth: 0.563888,
    strokeMiterlimit: 2.613
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4629 28.5416H12.701V25.6791H15.6729C16.746 25.6791 17.2412 25.27 17.2412 24.2073V22.5717C17.2412 21.5083 16.746 21.0999 15.6729 21.0999H11.4629V28.5416ZM15.1776 22.0806C15.7555 22.0806 16.0031 22.2444 16.0031 22.817V23.8798C16.0031 24.5341 15.7555 24.6979 15.1776 24.6979H12.701V22.0806H15.1776Z",
    fill: "#295BA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4629 28.5416H12.701V25.6791H15.6729C16.746 25.6791 17.2412 25.27 17.2412 24.2073V22.5717C17.2412 21.5083 16.746 21.0999 15.6729 21.0999H11.4629V28.5416ZM15.1776 22.0806C15.7555 22.0806 16.0031 22.2444 16.0031 22.817V23.8798C16.0031 24.5341 15.7555 24.6979 15.1776 24.6979H12.701V22.0806H15.1776Z",
    stroke: "#295BA7",
    strokeWidth: 0.563888,
    strokeMiterlimit: 2.613
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2324 22.8987V26.824C18.2324 28.1324 18.6453 28.5413 19.966 28.5413H23.0203C24.3412 28.5413 24.7538 28.1322 24.7538 26.824V22.8987C24.7538 21.508 24.3412 21.0994 23.0203 21.0994H19.9657C18.645 21.0996 18.2324 21.508 18.2324 22.8987ZM19.4705 27.4782V22.0806H23.5158V27.4782H19.4705Z",
    fill: "#295BA7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2324 22.8987V26.824C18.2324 28.1324 18.6453 28.5413 19.966 28.5413H23.0203C24.3412 28.5413 24.7538 28.1322 24.7538 26.824V22.8987C24.7538 21.508 24.3412 21.0994 23.0203 21.0994H19.9657C18.645 21.0996 18.2324 21.508 18.2324 22.8987ZM19.4705 27.4782V22.0806H23.5158V27.4782H19.4705Z",
    stroke: "#295BA7",
    strokeWidth: 0.563888,
    strokeMiterlimit: 2.613
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9094 28.5416H27.2299V25.6791H27.5601L30.6149 28.5416H32.5135L29.0463 25.6791H30.202C31.2751 25.6791 31.7706 25.27 31.7706 24.2073V22.5717C31.7706 21.5083 31.2751 21.0999 30.202 21.0999H25.9094V28.5416ZM29.7066 22.0806C30.202 22.0806 30.4494 22.2444 30.4494 22.817V23.9615C30.4494 24.5341 30.202 24.6979 29.7066 24.6979H27.2299V22.0806H29.7066Z",
    fill: "#295BA7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9094 28.5416H27.2299V25.6791H27.5601L30.6149 28.5416H32.5135L29.0463 25.6791H30.202C31.2751 25.6791 31.7706 25.27 31.7706 24.2073V22.5717C31.7706 21.5083 31.2751 21.0999 30.202 21.0999H25.9094V28.5416ZM29.7066 22.0806C30.202 22.0806 30.4494 22.2444 30.4494 22.817V23.9615C30.4494 24.5341 30.202 24.6979 29.7066 24.6979H27.2299V22.0806H29.7066Z",
    stroke: "#295BA7",
    strokeWidth: 0.563888,
    strokeMiterlimit: 2.613
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4654 22.4898H46.1347V21.263H45.8047V20.9358H46.7954V21.263H46.4654V22.4898ZM48.1159 21.5905L47.7859 22.5715H47.6211L47.2909 21.5905L47.1256 22.4898H46.7954L47.043 20.9358H47.2909L47.7033 21.9172L48.1159 20.9358H48.364L48.6113 22.4898H48.2814L48.1159 21.5905Z",
    fill: "#295BA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEaSports);
export default __webpack_public_path__ + "static/media/ea-sports.bd96909f9e939a4ee7427ce5bc2c0f10.svg";
export { ForwardRef as ReactComponent };